import erc20 from "./abis/erc20.json";
import TransformersNFT from "./abis/TransformersNFT.json";



export default {
  erc20,
  TransformersNFT
};
